var _circle, _circle2, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FBCBD4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#2E2E2E",
    strokeOpacity: 0.05
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0208,
    cy: 40,
    rx: 30.0208,
    ry: 30,
    fill: "#DC143C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5417 40C69.5417 56.2921 56.3251 69.5 40.0208 69.5C23.7166 69.5 10.5 56.2921 10.5 40C10.5 23.7079 23.7166 10.5 40.0208 10.5C56.3251 10.5 69.5417 23.7079 69.5417 40Z",
    stroke: "#2E2E2E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4199 48H41.957L39.1738 43.5371L36.4199 48H32.0547L36.791 40.6953L32.3379 33.7227H36.6152L39.1934 38.1367L41.6738 33.7227H46.0781L41.5566 40.998L46.4199 48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.abb7caf89a6357ba725ec721fdb4f9be.svg";
export { ForwardRef as ReactComponent };